import { render, staticRenderFns } from "./RiskTemplateItemExpanded.vue?vue&type=template&id=6f05610e&scoped=true&"
import script from "./RiskTemplateItemExpanded.vue?vue&type=script&lang=ts&"
export * from "./RiskTemplateItemExpanded.vue?vue&type=script&lang=ts&"
import style0 from "./RiskTemplateItemExpanded.vue?vue&type=style&index=0&id=6f05610e&scoped=true&lang=css&"
import style1 from "./RiskTemplateItemExpanded.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f05610e",
  null
  
)

export default component.exports